import React from 'react'
import { AiOutlineMinus } from "react-icons/ai"

const Work = () => {
  return (
    <div id="experience" className="main font-vic text-white w-full h-full py-6 md:py-14 px-2">
    <div className="container mx-auto w-full justify-center items-center flex flex-col  gap-4">
        <div className="flex flex-col w-full md:w-[60%] h-full">
        <div className="flex flex-col  w-full h-full gap-3 py-4">
            <p className="text-gray-600 text-[12px] md:text-[20px] font-semibold tracking-widest"> WORK EXPERIENCE</p>
        </div>
            
            <div className="flex flex-row  gap-10 h-full">
                <div className="flex flex-col justify-center items-center">

                <div className="border-2 border-teal-300 rounded-full p-2">
                    <div className="bg-teal-300 rounded-full p-1"></div>
                </div>
                <div className="w-1 bg-teal-300 h-full"></div>
                </div>
                <div className="flex flex-col gap-4 ">
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">Sparepap limited</p>
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">Jan 2023 - Present</p>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>Transformed the frontend with responsive and user-friendly interfaces, optimizing website performance and capturing a broader audience. Employed React to build interactive components, providing a smooth and engaging shopping experience.</p>
                    </div>
                    <div className="flex flex-row  gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                        As a Mid-Level Full Stack Developer at SparePap, I played a pivotal role in driving the success of our e-commerce platform. Leveraging my expertise in JavaScript, Django, React, and Django Rest Framework, I delivered innovative solutions that enhanced user experience and accelerated business growth.
                        Collaborated with a talented team to design and implement new features,including development of backend functionalities like payment gateways and order processing, ensuring seamless transactions and customer satisfaction.

                    </p>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    Continuously sought opportunities to optimize code efficiency, leading to a 20% improvement in site speed and performance. Conducted rigorous testing and debugging, ensuring the highest quality of deliverables.
                    </p>
                    </div>

                </div>
            </div>
            <div className="flex flex-row gap-10 h-full">
                <div className="flex flex-col justify-center items-center">

                <div className="border-2 border-teal-300 rounded-full p-2">
                    <div className="bg-teal-300 rounded-full p-1"></div>
                </div>
                <div className="w-1 bg-teal-300 h-full"></div>
                </div>
                <div className="flex flex-col gap-4 py-6">
                    <div className="flex gap-2 flex-col">
                        
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">Enthusiastic Art · Contract</p>
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">Nov 2022 - Present</p>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    As a Full Stack Developer at Enthusiastic Art, I played a pivotal role in shaping the technology landscape for our soon-to-be-launched e-commerce platform. Leveraging my expertise in JavaScript, Django, React, and Django Rest Framework, I contributed to building a robust and scalable foundation for our digital venture.
                    Collaborated closely with the team to design and implement the frontend, ensuring an intuitive and visually appealing user interface. Utilized React to craft dynamic components, creating a seamless and immersive shopping experience.
                    </p>
                    </div>
                    <div className="flex flex-row  gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    Developed and integrated backend functionalities, including user authentication, product catalog management, and secure payment gateways. Committed to delivering reliable and secure solutions that uphold the highest industry standards.

                    </p>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    Thrilled to be part of the Enthusiastic Art team, contributing to the inception of an innovative e-commerce platform that promises to revolutionize the art industry. Eager to embrace new challenges and drive the success of our upcoming launch.As a Full Stack Developer at Enthusiastic Art, I played a pivotal role in shaping the technology landscape for our soon-to-be-launched e-commerce platform. Leveraging my expertise in JavaScript, Django, React, and Django Rest Framework, I contributed to building a robust and scalable foundation for our digital venture. Collaborated closely with the team to design and implement the frontend, ensuring an intuitive and visually appealing user interface. Utilized React to craft dynamic components, creating a seamless and immersive shopping experience. Developed and integrated backend functionalities, including user authentication, product catalog management, and secure payment gateways. Committed to delivering reliable and secure solutions that uphold the highest industry standards. Thrilled to be part of the Enthusiastic Art team, contributing to the inception of an innovative e-commerce platform that promises to revolutionize the art industry. Eager to embrace new challenges and drive the success of our upcoming launch.

                    </p>
                    </div>

                </div>
            </div>
            <div className="flex flex-row gap-10 h-full">
                <div className="flex flex-col justify-center items-center">

                <div className="border-2 border-teal-300 rounded-full p-2">
                    <div className="bg-teal-300 rounded-full p-1"></div>
                </div>
                <div className="w-1 bg-teal-300 h-full"></div>
                <div className="border-2 border-teal-300 rounded-full p-2">
                    <div className="bg-teal-300 rounded-full p-1"></div>
                </div>
                </div>
                <div className="flex flex-col gap-4 py-6">
                    <div className="flex gap-2 flex-col">
                        
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">The Newberry institute · Contract</p>
                    <p className="text-gray-600 text-[12px] capitalize font-semibold tracking-widest">Sep 2022 - Present</p>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    As a Web Developer at The Newberry Institute, a distinguished non-governmental organization (NGO), my role encompasses a pivotal blend of technical expertise and humanitarian impact. My primary responsibilities center around designing, developing, and maintaining innovative internal applications that play a crucial role in efficiently managing and enhancing the organization's initiatives.
                    </p>
                    </div>
                    <div className="flex flex-row  gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    At The Newberry Institute, I have harnessed my proficiency in web development to create bespoke solutions tailored to the organization's specific needs. My foremost task involves crafting intuitive and user-friendly web applications that streamline the tracking of payment donations and food distribution. Through my coding prowess, I have contributed to the seamless flow of critical information within the organization, facilitating better decision-making and resource allocation.

                    </p>
                    </div>
                    <div className="flex flex-row items-center gap-2">
                        {/* <AiOutlineMinus size={30}/> */}
                    <p className='text-gray-400'>
                    In collaboration with cross-functional teams, I have leveraged my skills to implement cutting-edge technologies and methodologies. Through close interaction with stakeholders, I have translated complex requirements into elegant and effective software solutions. By continuously refining and optimizing these applications, I have played a pivotal role in enabling The Newberry Institute to efficiently manage its philanthropic endeavors and make a positive impact on the communities it serves.
                    </p>
                    </div>

                </div>
            </div>
        </div>
       
    </div>
</div>
  )
}

export default Work